import axios from "axios";
import { useNavigate } from "react-router-dom";
import { config, isDevMode } from "./Constants";

const URL = config.url;

const useMerchantPortalAxios = () => {

  const navigate = useNavigate();

  const MerchantPortalClient = axios.create({
    baseURL: URL,
    timeout: isDevMode ? 300000 : 15000,
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem("Token"),
    },
  });

  MerchantPortalClient.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error.response.status === 401) {
          sessionStorage.clear();
          navigate("/", { replace: true });
        }

        return Promise.reject(error);
      }
  );

  return MerchantPortalClient;
}
export  const useMerchantPortalFormData = () => {
  const MerchantPortalClient = axios.create({
    baseURL: URL,
    timeout: isDevMode ? 300000 : 15000,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: sessionStorage.getItem("Token"),
    },
  });

  return MerchantPortalClient;
}

export default useMerchantPortalAxios


